var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-link",class:{wide: _vm.isWide},attrs:{"to":{name: _vm.menuName.toLowerCase()}}},[_c(_vm.menuName,{tag:"component"}),_c('div',{staticClass:"menu-name"},[_c('span',[_vm._v(_vm._s(_vm.menuName))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }